/**
 * One id per API call. The fetcher sends it as `X-Request-Id`; the backend echoes and logs it, so a frontend
 * error can be matched to the backend log line.
 */
export const createRequestId = (): string => {
  return crypto.randomUUID();
};
